import { rankItem, rankings } from "@tanstack/match-sorter-utils";

export function normalizeLibrarySearch(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[’']/g, "")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

// At most one insertion, deletion, substitution, or adjacent transposition.
function isWithinOneEdit(first: string, second: string): boolean {
  if (Math.abs(first.length - second.length) > 1) return false;
  let left = 0;
  let right = 0;
  let edits = 0;

  while (left < first.length && right < second.length) {
    if (first[left] === second[right]) {
      left += 1;
      right += 1;
      continue;
    }
    edits += 1;
    if (edits > 1) return false;
    if (first.length > second.length) left += 1;
    else if (second.length > first.length) right += 1;
    else if (first[left] === second[right + 1] && first[left + 1] === second[right]) {
      left += 2;
      right += 2;
    } else {
      left += 1;
      right += 1;
    }
  }

  return edits + (first.length - left) + (second.length - right) <= 1;
}

export function matchesLibraryQuery(entry: { title: string; words: string[] }, queryWords: string[]): boolean {
  return queryWords.every(
    (word) =>
      // Keep title fragments and acronyms, without arbitrary skipped-letter matches.
      rankItem(entry.title, word, { threshold: rankings.ACRONYM }).passed
      || (word.length >= 4 && entry.words.some((titleWord) => isWithinOneEdit(word, titleWord))),
  );
}
